// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"05d6dec2","6850":"975e6675"}[chunkId] + ".chunk.css";
};